import { type Key } from 'react-aria-components';
import { Button, DropdownSelector } from '@repo/design-system-kit';
import { IconTrashOutlined } from '@repo/monochrome-icons';
import { useSegment } from '@repo/poly-hooks/segment';
import type { OperatorOption } from '../../../types/filters';
import styles from './filters-list-header.module.css';

const DELETE_FILTER_TRACKING_EVENT = 'delete_filter';

interface FiltersListHeaderProps {
  filterKey: string;
  label: string;
  operator?: OperatorOption;
  operators?: OperatorOption[];
  onOperatorChange?: (operator: Key) => void;
  onDelete?: () => void;
}

export function FiltersListHeader({
  filterKey,
  label,
  operator,
  operators,
  onOperatorChange,
  onDelete,
}: FiltersListHeaderProps) {
  const segment = useSegment();

  return (
    <div className={styles.container}>
      <span className={styles.label}>{label}</span>
      {operators && operators.length > 1 && onOperatorChange ? (
        <DropdownSelector
          buttonSize="sm"
          items={operators.map(op => ({ ...op, key: op.displayKey ?? op.key }))}
          onSelectionChange={onOperatorChange}
          selectedKey={operator?.displayKey ?? operator?.key}
        />
      ) : null}
      {onDelete ? (
        <Button
          className={styles.deleteButton}
          iconOnly
          onPress={() => {
            onDelete();
            segment.track(DELETE_FILTER_TRACKING_EVENT, {
              filter_name: filterKey,
            });
          }}
          size="small"
          variant="tertiary"
        >
          <IconTrashOutlined aria-hidden="true" />
        </Button>
      ) : null}
    </div>
  );
}
